// thunk.js

import { logout } from "./reducer";

import _BaseAPIService from "../../../services/_BaseAPIService";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";
import JSON5 from "json5";
import { getApiBase } from "../../../utilis/config";
import { Capacitor, CapacitorHttp } from "@capacitor/core";

const authUser = getLoggedInUser();
console.log("authUserr", authUser);

const API_PATH =
  "/Modules/ROPurchaseOrder/ROPurchaseOrderWebService.asmx/CheckPin";

export const login = (pin, history) => {
  return async (dispatch) => {
    try {
      const base = await getApiBase();
      const apiUrl = `${base}${API_PATH}`;
      const body = `pin=${encodeURIComponent(pin)}`;

      let raw;

      if (Capacitor.getPlatform() !== "web") {
        // Native (Android/iOS) → CapacitorHttp automatically parses JSON
        const response = await CapacitorHttp.post({
          url: apiUrl,
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: body,
        });
        raw = response.data; // already an object
      } else {
        // Web → fetch (CORS may require proxy)
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body,
        });
        const text = await response.text();
        try {
          raw = JSON5.parse(text); // parse JSON string
        } catch (e) {
          console.error("Web JSON parse error:", text);
          throw new Error("Invalid server response");
        }
      }

      const { statusCode, message, data } = raw;
      console.log("🚀 ~ login ~ raw:", raw);

      if (statusCode === 200 && data?.Message === "Success") {
        const user = {
          UserID: data.UserID,
          UserName: data.UserName,
          Roles: data.Roles,
          DisablePin: data.DisablePin,
          OrderMenuListType: data.OrderMenuListType,
          OrderMenuImageshow: data.OrderMenuImageshow,
        };

        // Store user in BaseAPIService if available
        if (typeof _BaseAPIService !== "undefined") {
          _BaseAPIService.storeUser(user);
        }

        dispatch({ type: "LOGIN_SUCCESS", payload: user });
        history.push("/pos");
      } else {
        dispatch({ type: "LOGIN_FAILURE", payload: message || "Invalid PIN" });
      }
    } catch (error) {
      console.error("Login error:", error);
      dispatch({
        type: "LOGIN_FAILURE",
        payload: error.message || "Network error",
      });
    }
  };
};

export const logoutUser = () => (dispatch) => {
  // Clear the user data and token from local storage.
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("lastCalendarView");

  // Dispatch the logout action.
  dispatch(logout());
};
